import { render } from "./KvnGame.vue?vue&type=template&id=c6c84148"
import script from "./KvnGame.vue?vue&type=script&lang=js"
export * from "./KvnGame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__